"use strict";
(
    function (skyward, $) {
        var init = function (selector) {
            $(selector).find(".fileDestinationLocation").each(function () { fileDestinationLocation().registerFileDestinationLocation($(this)); });
        };

        function fileDestinationLocation() {
            var hiddenControl;
            var multiSelectEEL;
            var securityHashControl;
            var ftpHashesExist;

            function registerFileDestinationLocation(fileDestinationLocation) {
                hiddenControl = fileDestinationLocation.find(".fileDestinationLocationBackingData");
                multiSelectEEL = fileDestinationLocation.find(".fileDestinationLocationMultiSelectEEL");
                multiSelectEEL.on("change", afterSelection);

                updateControlVisibility();
            }

            var afterSelection = function () {
                var dmseValue = multiSelectEEL.find(".dmsBackingData").val();
                if (dmseValue != "{}") {
                    var json = JSON.parse(dmseValue);
                    var primaryKeyCollection = [];
                    for (var key in json) {
                        primaryKeyCollection.push(key);
                    }

                    if (primaryKeyCollection.length == 1) {
                        hiddenControl.val(primaryKeyCollection[0]);
                    }
                    else {
                        hiddenControl.val(primaryKeyCollection);
                    }
                }
                else {
                    hiddenControl.val(null);
                }

                if (ftpHashesExist) {
                    securityHashControl.data("ftpconnectionid_securityhash", ftpConnection_SecurityHash);
                    securityHashControl.data("pagestatemodifycontrol_securityhash", pageStateModifyControl_SecurityHash);
                }

                updateControlVisibility();
            }

            function updateControlVisibility() {
                var fileDestinationID = hiddenControl.val();

                if (fileDestinationID && fileDestinationID != "")
                {
                    hiddenControl.trigger("dirty");
                }
            }

            return { registerFileDestinationLocation: registerFileDestinationLocation };
        };

        skyward.window.registerLoadDOMCallback(init);
    })(skyward || {}, window.jQuery);
